import { Swiper, SwiperSlide } from 'swiper/react';
import './styles.css'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { formatDateNormal, getLocale } from '../../helpers/dates';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export default function EventGallery({ events, lng }) {
  const locale = getLocale(lng);
  const history = useHistory();

  const onEventClick = (e) => {
    history.push({
      pathname: '/event',
      search: `?eventId=${e.id}`,
    });
  };

  return (
    <>
      <div className='event-list'>
        <Swiper spaceBetween={25} slidesPerView={'auto'}>
          {events?.map((item, x) => (
            <SwiperSlide key={`slide_${x}`}>
              <div className='gallery-image' onClick={() => onEventClick(item)}>
                <div>
                  <img src={item.bannerImage} />
                </div>
                <div className='font-tiny fw-bold mt-2'>{item.name}</div>
                <div className='font-tiny text-lighter-gray mt-2'>
                  {formatDateNormal(item.startDate, locale)}
                </div>
                <div className='font-tiny text-lighter-gray mt-2'>{item.show?.name}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
